import { useTranslation } from 'react-i18next';
import styled from 'styled-components'
import { typeface, get_color, respond, size_fixed_w } from '../assets/styles/index';
import logo from '../assets/images/hs_logo.svg';
import years from '../assets/images/88years.svg';
import imgChevronUpGreen from '../assets/images/icn_stroke_chevron_up_hase_green.svg';
import imgChevronDownGreen from '../assets/images/icn_stroke_chevron_down_hase_green.svg';
import imgChevronDownGrey from '../assets/images/icn_stroke_chevron_down_grey02.svg';
import {useState } from 'react';
import React from 'react';
import { view } from '../utils/url';
import { dayAfterScheduledDate } from '../utils/scheduleDate';

const HeaderBox = styled('div')`
  border-bottom: 4px solid ${get_color('green02')};
  padding: 24px 0px;
  display: flex;
  justify-content: center;
  ${respond(['t'], `
    border-bottom: 7px solid ${get_color('green02')};
  `)}
  ${respond(['m'], `
    padding: 12px 18px;
  `)}
  ${respond(['s'], `
    padding: 12px;
  `)}
`;

const HeaderContainer = styled('div')`
  display: flex;
  justify-content: space-between;
  width: 100%;
  ${respond(['t'], `
    ${size_fixed_w('972px')}
    padding: 0 26px;
  `)}
`;

const HeaderItem = styled('div')`
  display: flex;
  align-items: center;
  .link{
    display: flex;
  }
`;

const Logo = styled('img')`
  width: 396px;
  ${respond(['m'], `
    width: 301px;
  `)}
  ${respond(['s'], `
    width: 197px;
  `)}
`;

const Years = styled('img')`
  width: 68px;
  padding-right: 24px;
  ${respond(['m'], `
    width: 49px;
    padding-right: 20px;
  `)}
  ${respond(['s'], `
    width: 32px;
    padding-right: 12px;
  `)}
`;

const LangDropdown = styled('div') <{ isActive: boolean }>`
  position: relative;
  button {
    ${typeface('body6')}
    align-items: center;
    cursor: pointer;
    width: 85px;
    background-color: ${props => props.isActive ? get_color('grey09') : get_color('white')};
    border: 1px solid ${get_color('grey06')};
    border-radius: 3px;
    color: ${get_color('green01')};
    display: flex;
    padding: 7px 21px;
    ${props => props.isActive && 
      `
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      `
    }
    &:after{
      content: "";
      background-image: url(${props => props.isActive ? imgChevronUpGreen : imgChevronDownGrey });
      display: inline-block;
      width: 16px;
      height: 16px;
      background-size: cover;
      margin-left: 10px;
    }
    &:hover {
      text-decoration: underline;
      background-color: ${get_color('grey09')};
      ${props => !props.isActive && `
        &:after{
          background-image: url(${imgChevronDownGreen});
        }
        `
      }
    }
  }
  .drop-down-list{
    ${typeface('body7')}
    display: ${props => props.isActive ? 'flex' : 'none'};
    flex-direction: column;
    position: absolute;
    overflow: hidden;
    width: calc( 100% - 2px);
    background-color: ${get_color('white')};
    border: 1px solid ${get_color('grey06')};
    border-top: none;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
    .option{
      background-color: ${get_color('white')};
      text-align: center;
      padding: 7px 21px;
      color: ${get_color('grey02')};
      cursor: pointer;
      text-decoration: none;
      &:not(:first-child){
        border-top: 1px solid ${get_color('grey06')};
      }
      :hover{
        color: ${get_color('green01')};
        background-color: ${get_color('grey09')};
      }
    }
  }
`;
interface Language {
  value: string;
  label: string;
  folder: string;
}

const langArr: Language[] = [
  {value: 'en-HK',label: 'EN' ,folder: 'eng'},
  {value: 'zh-HK',label: '繁' ,folder: 'chi'},
  {value: 'zh-CN',label: '简' ,folder: 'schi'}
]

const getLangObj = (lang:string) => {
  return langArr.find((item)=>{
    return item.value === lang;
  }) ?? langArr[0];
}

const Header = React.forwardRef<HTMLAnchorElement>((props, ref) => {
  const { t, i18n } = useTranslation();
  const [dropdown, setDropdown] = useState(false);
  // const [lang, setLang] = useState<Language>(getLangObj(i18n.language));

  // const changeLang = (nextLang:string) =>{
  //   setLang(getLangObj(nextLang));
  //   setDropdown(false);
  // }

  // useEffect(() => {
  //   i18n.changeLanguage(lang.value);
  // }, [lang, i18n])
  const replaceLangCodetoUrl = ( langCode:string ) =>{
    return window.location.href.replace(/\/(chi|schi|eng)\//, `/${langCode.toLowerCase()}/`);
  }

  const langList = langArr.filter((item)=>{
    return item.value !== i18n.language;
  }).map((item)=>{
    return <a href={replaceLangCodetoUrl(item.folder)} className="option" key={item.value} lang={item.value}>{item.label}</a>;
  })

  return (
    <HeaderBox>
      <HeaderContainer>
        <HeaderItem>
          {view !== 'p2g'?(<a className="link" ref={ref} href={"https://www.hangseng.com/"+ i18n.language.toLowerCase() + "/home/"}><Logo src={logo} alt={t('hangseng')} /></a>)
          : (<Logo src={logo} alt={t('hangseng')} />) }
        </HeaderItem>
        <HeaderItem>
          {dayAfterScheduledDate !== true && <Years src={years} alt={t('88years')} />}
          <LangDropdown isActive={dropdown}>
            <button aria-expanded={dropdown} onClick={() => setDropdown(!dropdown)}>{getLangObj(i18n.language).label}</button>
            <li className='drop-down-list'>
              {langList}
            </li>
          </LangDropdown>
        </HeaderItem>
      </HeaderContainer>
    </HeaderBox>
  );
});

export default Header;
